import React, {useContext, useEffect, useState} from "react";
import {BrandContext} from "../../common/BrandContext";
import useHotmathsIcon from "../../hooks/useHotmathsIcon";

const ClassDetailsWeeklySummaryCard = ({ cardDetails }) => {
    const brandConfig = useContext(BrandContext);
    const [iconString, setIconString] = useState('tests');
    const [cardName, setCardName] = useState('Class item')
    const icon = useHotmathsIcon(iconString);

    const getIconString = (details) => {
        if(details.testPurpose){
            const { testPurpose } = details;
            if(testPurpose === 'TEST') setIconString('tests');
            if(testPurpose.includes('DIAGNOSTIC')) setIconString('diagnostic-tests');
        }
        if(details.pathwayType){
            setIconString('manage-pathways')
        }
    }

    const getCardName = (details) => {
        if(details.testPurpose){
            if(details.testPurpose){
                const { testPurpose, testPurposeDescription } = details;

                if(testPurpose === 'TEST') {
                    setCardName(`${brandConfig.testName}: ${details.testName}`);
                } else if(testPurpose === 'EXAM') {
                    setCardName(`Exam: ${details.testName}`);
                } else if(testPurpose.includes('DIAGNOSTIC') &&
                    !testPurposeDescription?.includes('Adaptive pre-test') && !testPurposeDescription?.includes('Adaptive post-test')) {
                    setCardName(`Diagnostic: ${details.testName}`);
                } else {
                    setCardName(`${details.testName}`);
                }
            }
        }
        if(details.pathwayType){
            setCardName(`${brandConfig.taskName}: ${details.pathwayAssignmentName}`);
        }
    }

    useEffect(() => {
        if(cardDetails){
            getIconString(cardDetails);
            getCardName(cardDetails);
        }
    }, [cardDetails]);

    const getHumanAssignedOrDueDate = (assignedTime, dueTime) => {
        const options = {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        if (!dueTime) {
            return `Assigned: ${new Date(assignedTime).toLocaleString('en-US', options)}`;
        }

        const now = Date.now();
        const label = dueTime < now ? 'Finished' : 'Due';
        return `${label}: ${new Date(dueTime).toLocaleString('en-US', options)}`;
    };

    const getHumanStudentsComplete = (details) => {
        if(details.pathwayType){
            return(
                <p><strong>{`${details.completedStudentIds.length} / ${details?.studentsTotal}`}</strong><br /> Students complete</p>
            )
        }
        if(details.studentsTotal !== undefined && details.studentsTotal !== null){
            const studentsComplete = Math.round(details.studentsTotal * (details?.percentStudentsComplete / 100));
            return(
                <p><strong>{`${studentsComplete} / ${details?.studentsTotal}`}</strong><br /> Students complete</p>
            )
        }
        return('')
    }

    return (
        <div className={`ch-class-details-weekly-summary-card color-${iconString}`}>
            <div className={'ch-class-details-weekly-summary-card-icon'}>
                {icon}
            </div>
            <div>
                <p className={'ch-class-details-weekly-summary-card-title'}>{cardName}</p>
                <p>{getHumanAssignedOrDueDate(cardDetails.assignedDate, cardDetails.endDate)}</p>
            </div>
            <div>
                {getHumanStudentsComplete(cardDetails)}
            </div>
        </div>
    )
};

export default ClassDetailsWeeklySummaryCard;